<template>
  <div class="fixed--btn" :class="customCss">
    <slot>
      <button :class="[variant]">
        <span class="material-icons material-icons-outlined">
          add
        </span>
      </button>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'pill' || 'circle' || 'square',
    },
    customCss: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss">
.fixed--btn {
  position: fixed;
  bottom: 0;
  right: 0;

  & .pill {
    padding: 1rem 3rem;
    border-radius: 20px;
  }

  & .circle {
    border-radius: 50%;
  }

  & .square {
    border-radius: 10px;
  }

  & .circle,
  & .square {
    padding: 1rem;
  }
}
</style>
